export default "__VITE_ASSET__BMgWzKjF__"